import React, { useRef, useEffect, useState } from "react";
import { NUMBER } from "../../../constants/app-constants";
import PropTypes from "prop-types";
import styles from "./styles.css";

const AutoScroll = ({
    speed = NUMBER.THIRTY,
    overflow = "hidden",
    gap = "1rem",
    children
}) => {
    const [contentWidth, setContentWidth] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        const updateContentWidth = () => {
            if (contentRef.current) {
                setContentWidth(contentRef.current.offsetWidth);
            }
        };

        updateContentWidth();
        window.addEventListener("resize", updateContentWidth);

        return () => window.removeEventListener("resize", updateContentWidth);
    }, [children]);

    const marqueeStyle = {
        "--marquee-speed": `${speed}s`,
        "--content-width": `${contentWidth}px`,
        "--overflow": `${overflow}`,
        "--gap": `${gap}`
    };

    return (
        <div styleName={"styles.marqueeContainer"} style={marqueeStyle}>
            <div styleName={"styles.marquee"}>
                <div
                    ref={contentRef}
                    styleName={"styles.marqueeContent"}
                    style={{
                        marginRight: gap
                    }}
                >
                    {children}
                </div>
                <div styleName={"styles.marqueeContent"} aria-hidden="true">
                    {children}
                </div>
            </div>
        </div>
    );
};

AutoScroll.propTypes = {
    speed: PropTypes.number,
    overflow: PropTypes.string,
    gap: PropTypes.string,
    children: PropTypes.object
};

export default AutoScroll;
